import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "antd";

import { useLocation } from "react-router-dom";
import { accessChecker } from "../../lib/functions"; 
import Invoice from "../Sales/Invoice";
import SalesRecord from "../SalesRecord";
import SalesVoucher from "../SalesVoucher";
import InvoicePharma from "../SalesPharma/Invoice";

const SalesTabs = ({ authInfo }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";


  let menuData = [
    {
      label: "Sales Entry",
      key: "entry",
      value: "new_sales",
      children: (
        <>
          <Invoice authInfo={authInfo} />
        </>
      ),
    },
    {
      label: "Pharma Sales",
      key: "pharma_sales",
      value: "pharma_sales",
      children: (
        <>
          <InvoicePharma authInfo={authInfo} />
        </>
      ),
    },
    {
      label: "Sales Record",
      key: "record",
      value: "sales_record",
      children: (
        <>
          <SalesRecord />
        </>
      ),
    },
    {
      label: "Sales Voucher",
      key: "voucher",
      value: "sales_voucher",
      children: (
        <>
          <SalesVoucher />
        </>
      ),
    },
  ];

  if (authInfo?.branch_company_type === "Pharmacy") {
    menuData = menuData.filter((tab) => tab.key !== "entry");
  }

    if (authInfo?.branch_company_type != "Pharmacy") {
    menuData = menuData.filter((tab) => tab.key !== "pharma_sales");
  }

  const filteredMenuData = menuData.filter((menuItem) =>
    accessChecker(menuItem.value)
  );

  return (
    <Tabs
      defaultActiveKey={activeTab}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={filteredMenuData}
    />
  );
};

export default SalesTabs;
